import moment from 'moment';
import { falsyParamsFilter } from '@/utils/format';

// 计算模式
export const CALCMODE = {
  1: '固定值计算',
  2: '单位计算',
  3: '全量阶梯计算',
  4: '复合计算',
};
export const CALCLOGIC = {
  1: '求和',
};
// 聚合维度
export const GROUPMODE = {
  1: '任务行',
  2: '票',
  3: '波次',
};
export const NUMBERTEXT = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];

export function intToChinese(str) {
  str = str + '';
  var len = str.length - 1;
  var idxs = [
    '',
    '十',
    '百',
    '千',
    '万',
    '十',
    '百',
    '千',
    '亿',
    '十',
    '百',
    '千',
    '万',
    '十',
    '百',
    '千',
    '亿',
  ];
  var num = NUMBERTEXT;
  return str.replace(/([1-9]|0+)/g, function($, $1, idx, full) {
    var pos = 0;
    if ($1[0] != '0') {
      pos = len - idx;
      if (idx == 0 && $1[0] == 1 && idxs[len - idx] == '十') {
        return idxs[len - idx];
      }
      return num[$1[0]] + idxs[len - idx];
    } else {
      var left = len - idx;
      var right = len - idx + $1.length;
      if (Math.floor(right / 4) - Math.floor(left / 4) > 0) {
        pos = left - (left % 4);
      }
      if (pos) {
        return idxs[pos] + num[$1[0]];
      } else if (idx + $1.length >= len) {
        return '';
      } else {
        return num[$1[0]];
      }
    }
  });
}

export const GroupModeTipsText = [
  '聚合维度支持按波次、票和任务行进行聚合，',
  '选择波次会将波次号相同的作业单据进行聚合后计薪，',
  '选择票会将订单号/运单号相同的作业单据进行聚合后计薪，',
  '选择件会按SKU号相同的作业单据进行聚合后计薪。',
];

// 拣货/播种对应聚合维度为：任务行、波次
// 复核/退货质检对应聚合维度为：任务行、票
export const getGroupModeConf = (workContent = '') => {
  if (workContent === '拣货' || workContent === '播种') {
    return {
      1: '任务行',
      3: '波次',
    };
  }
  if (
    workContent === '复核' ||
    workContent === '退货质检' ||
    workContent === '包装' ||
    workContent === '发运' ||
    workContent === '上架' ||
    workContent === '移库' ||
    workContent === '收货'
  ) {
    return {
      1: '任务行',
      2: '票',
    };
  }
  return {
    1: '任务行',
  };
};
// 单位
export const UNIT = [
  {
    label: 'SKU数',
    value: 1,
  },
  {
    label: '件数',
    value: 2,
  },
  {
    label: '箱数',
    value: 3,
  },
  {
    label: '体积',
    value: 4,
  },
];
// 运算符
export const CALCSYMBOL = [
  {
    label: '<',
    value: 1,
  },
  {
    label: '<=',
    value: 2,
  },
];
// 表单响应式布局
export const formItemLayout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};
// 计薪参数模板
export const PAY_ARG_DEFINE = {
  param_id: undefined, //  参数ID
  operator: undefined, //	str	必填	参数关系
  type: undefined, //	int	必填	1数值 2枚举 3文本
  value: undefined, //
};
// 计薪条件模板
export const PAY_PLAN_DEFINE = {
  paid_params: [
    PAY_ARG_DEFINE, //	计薪参数 可包含多组计薪参数
  ],
  fixed_value: undefined, //	str	否	固定数值 支持小数 计算模式为固定值计算时必填
  unit: undefined, //	int	否	单位计算中的单位 1：SKU数 2：件数 3：箱数 4：体积 计算模式为单位计算时必填
  unit_work_time: undefined, //	str	否	单位计算中每单位数值 支持小数 计算模式为单位计算时必填
  sub_compute_mode: 1, //  int	否	子计算模式 计算模式为全量阶梯计算时必填 1: 固定值计算 2：单位计算
};
// 阶梯方案模板
export const STAGE_PAY_PLAN_DEFINE = [
  {
    paid_params: {
      //  阶梯条件 start
      left_value: 0, //全量阶梯条件左边的值
      left_operator: '<=', //全量阶梯条件左边的操作符
      right_value: undefined, //全量阶梯条件右边的值
      right_operator: '<=', //全量阶梯右边的操作符
      // "ladder_unit":1         //全量阶梯阶梯单位  1：SKU数 2：件数 3：箱数 4：体积
    },
    fixed_value: undefined, //	str	否	固定数值 支持小数 计算模式为固定值计算时必填
    unit: undefined, //	int	否	单位计算中的单位 1：SKU数 2：件数 3：箱数 4：体积 计算模式为单位计算时必填
    unit_work_time: undefined, //	str	否	单位计算中每单位数值 支持小数 计算模式为单位计算时必填
    sub_compute_mode: undefined,
  },
  {
    paid_params: {
      left_value: undefined, //全量阶梯条件左边的值
      left_operator: '<', //全量阶梯条件左边的操作符
      right_value: 99999999, //全量阶梯条件右边的值
      right_operator: '<=', //全量阶梯右边的操作符
      // "ladder_unit":1           //全量阶梯阶梯单位  1：SKU数 2：件数 3：箱数 4：体积
    },
    fixed_value: undefined, //	str	否	固定数值 支持小数 计算模式为固定值计算时必填
    unit: undefined, //	int	否	单位计算中的单位 1：SKU数 2：件数 3：箱数 4：体积 计算模式为单位计算时必填
    unit_work_time: undefined, //	str	否	单位计算中每单位数值 支持小数 计算模式为单位计算时必填
    sub_compute_mode: undefined,
  },
];

// 阶梯计算 单条模板
export const STAGE_PAY_STAGE_DEFINE = {
  paid_params: {
    left_value: 0, //全量阶梯条件左边的值
    left_operator: '<=', //全量阶梯条件左边的操作符
    right_value: 0, //全量阶梯条件右边的值
    right_operator: '<=', //全量阶梯右边的操作符
    ladder_unit: 1, //全量阶梯阶梯单位
  },
  fixed_value: '', //	str	否	固定数值 支持小数 计算模式为固定值计算时必填
  unit: '', //	int	否	单位计算中的单位 1：SKU数 2：件数 3：箱数 4：体积 计算模式为单位计算时必填
  unit_work_time: '', //	str	否	单位计算中每单位数值 支持小数 计算模式为单位计算时必填
  sub_compute_mode: '',
};
// 固定值计算
export const CALCMODE1_CONFIG = {
  compute_mode: '1', //  计算模式  1: 固定值计算  2：单位计算  3: 全量阶梯结算  4: 复合计算
  aggregate_dim: undefined, //  聚合维度  1：件 2：票 3：波次
  plans: [PAY_PLAN_DEFINE], //  计薪条件
};
// 单位计算
export const CALCMODE2_CONFIG = {
  compute_mode: '2', //  计算模式  1: 固定值计算  2：单位计算  3: 全量阶梯结算  4: 复合计算
  aggregate_dim: undefined, //  聚合维度  1：任务行 2：票 3：波次
  plans: [
    {
      ...PAY_PLAN_DEFINE,
      sub_compute_mode: 2,
    },
  ], //  计薪条件
  unit: undefined,
  unit_work_time: undefined, //  每单位数值 支持小数 计算模式为单位计算时必填
};
// 全量阶梯计算
export const CALCMODE3_CONFIG = {
  compute_mode: '3', //  计算模式  1: 固定值计算  2：单位计算  3: 全量阶梯结算  4: 复合计算
  aggregate_dim: '1', //  聚合维度  1：任务行 2：票 3：波次
  plans: [
    {
      ladder_unit: undefined, // 阶梯单位
      // 计薪参数
      paid_plan_param: [
        PAY_ARG_DEFINE, //	计薪参数 可包含多组计薪参数
      ],
      paid_params: [...STAGE_PAY_PLAN_DEFINE], // 阶梯值
    },
  ],
};
export const CALCMODE4_CONFIG = [
  {
    paid_params: [
      {
        param_id: undefined,
        operator: undefined,
        type: undefined,
        value: undefined,
      },
    ],
    unit: undefined,
    unit_work_time: undefined,
    sub_compute_mode: '1',
  },
  {
    paid_params: [
      {
        param_id: undefined,
        operator: undefined,
        type: undefined,
        value: undefined,
      },
    ],
    unit: undefined,
    unit_work_time: undefined,
    sub_compute_mode: '2',
  },
];
// 计薪方案标准字段列表
export const POST_STAND_BASE = ['', '', '', '', '', ''];

// 生成唯一key string: 层级表示字符串 index: 数组下标
export const generateUniqKey = (string, index) => {
  return string + Date.now() + index;
};

// 去除数据中被删除的计算模式或计薪条件
export const formatPlanData = (planData) => {
  const copy = JSON.parse(JSON.stringify(planData));
  const result = copy.filter((mode) => !mode.hide);
  result.forEach((mode) => {
    mode.plans = mode.plans.filter((condition) => !condition.hide);
  });
  return result;
};

export const postFormat = (d) => {
  const { planData } = d;
  const newPlanData = planData.map((plan) => {
    const { plans, compute_mode } = plan;
    const newPlan = { ...plan };

    let newPlans = [...plans];
    // 子计算模式 = 固定值
    if (compute_mode === '1') {
      newPlans = plans.map((subPlan) => {
        const newObj = {
          ...subPlan,
        };
        delete newObj.unit;
        delete newObj.unit_work_time;
        delete newObj.sub_compute_mode;
        return {
          ...newObj,
        };
      });
      delete newPlan.unit;
      delete newPlan.unit_work_time;
    }
    // 子计算模式 = 单位计算
    if (compute_mode === '2') {
      newPlans = plans.map((subPlan) => {
        const newObj = {
          ...subPlan,
        };
        delete newObj.fixed_value;
        delete newObj.sub_compute_mode;
        return {
          ...newObj,
        };
      });
    }
    // 子计算模式 = 全量阶梯
    if (compute_mode === '3') {
      let tempPlans = [];
      plans.forEach((subPlan, index) => {
        subPlan.paid_params.forEach((item) => {
          const temp = {
            ...item,
            paid_params: {
              ...item.paid_params,
              paid_plan_param: subPlan.paid_plan_param,
              ladder_unit: subPlan.ladder_unit,
            },
            plan_flag: index + 1,
          };
          tempPlans.push(temp);
        });
      });
      newPlans = tempPlans;
    }
    return {
      ...plan,
      plans: newPlans,
    };
  });
  // 时间戳处理 :start =  0时0分0秒 ， end = 23时59分59秒
  const start = moment(d.validTimeBegin * 1000)
    .startOf('day')
    .format('X');
  const end = moment(d.validTimeEnd * 1000)
    .endOf('day')
    .format('X');
  return {
    ...d,
    validTimeBegin: start,
    validTimeEnd: end,
    planData: JSON.stringify(newPlanData),
  };
};

export const postCheck = (d) => {
  const fd = falsyParamsFilter(d);
  const required = {
    planName: '方案名称',
    taskType: '任务大类',
    customerGroupId: '货主组',
    validTimeBegin: '有效期开始时间',
    validTimeEnd: '有效期结束时间',
    workContentId: '工作环节',
    workContent: '工作环节',
    computeMode: '计算模式',
    planData: '方案配置',
  };
  const errmsg = [];
  Object.keys(required).forEach((k) => {
    if (!fd[k]) errmsg.push(required[k]);
  });
  // todo 计算模式校验
  if (errmsg.length) return errmsg;
  const top = fd.compute_mode;
  const requiredPlan = {
    aggregate_dim: '聚合维度',
    plans: '计薪条件',
    fixed_value: '固定值',
    param_id: '计薪参数',
    operator: '运算符',
    value: '计薪参数值',
    unit: '每单位单位',
    unit_work_time: '每单位标工',
    left_value: '阶梯左值',
    left_operator: '阶梯左操作符',
    right_operator: '阶梯右操作符',
    right_value: '阶梯右值',
    ladder_unit: '全量阶梯阶梯单位',
  };
  const modePlanCheckedMap = {
    1: ['aggregate_dim', 'plans'],
    2: ['aggregate_dim', 'plans'],
    3: ['aggregate_dim', 'plans'],
  };
  const modePlanParamsCheckedMap = {
    1: [['fixed_value'], ['param_id', 'operator', 'type', 'value']],
    2: [['unit', 'unit_work_time'], ['param_id', 'operator', 'type', 'value']],
  };
  const first = fd.planData[0];
  const firstfd = falsyParamsFilter(first);
  const plans = firstfd.plans;
  if (top === '1') {
    modePlanCheckedMap['1'].forEach((k) => {
      if (!firstfd[k]) errmsg.push(requiredPlan[k]);
    });
    if (errmsg.length) return errmsg;
    const planCheckedKey = modePlanParamsCheckedMap['1'][0];
    const planParamsKey = modePlanParamsCheckedMap['1'][1];
    plans.forEach((plan) => {
      planCheckedKey.forEach((pk) => {
        if (!plan[pk]) errmsg.push(requiredPlan[pk]);
      });
      if (plan.paid_params.length > 0) {
        plan.paid_params.forEach((param) => {
          planParamsKey.forEach((ppk) => {
            if (!param[ppk]) errmsg.push(requiredPlan[ppk]);
          });
        });
      }
    });
  } else if (top === '2') {
    modePlanCheckedMap['2'].forEach((k) => {
      if (!firstfd[k]) errmsg.push(requiredPlan[k]);
    });
    if (errmsg.length) return errmsg;
    const planCheckedKey = modePlanParamsCheckedMap['2'][0];
    const planParamsKey = modePlanParamsCheckedMap['2'][1];
    plans.forEach((plan) => {
      planCheckedKey.forEach((pk) => {
        if (!plan[pk]) errmsg.push(requiredPlan[pk]);
      });
      if (plan.paid_params.length > 0) {
        plan.paid_params.forEach((param) => {
          planParamsKey.forEach((ppk) => {
            if (!param[ppk]) errmsg.push(requiredPlan[ppk]);
          });
        });
      }
    });
  } else if (top === '3') {
    if (errmsg.length) return errmsg;
    const planCheckedKey = [['unit', 'unit_work_time'], ['fixed_value']];
    plans.forEach((plan, idx) => {
      if (!plan.ladder_unit) errmsg.push(requiredPlan.ladder_unit);
      if (errmsg.length) return errmsg;
      const painTemp = ['param_id', 'operator', 'type', 'value'];
      plan.paid_plan_param.forEach((param) => {
        painTemp.forEach((ppk) => {
          if (!param[ppk]) errmsg.push(requiredPlan[ppk]);
        });
      });
      plan.paid_params.forEach((paid_param, itemIndex) => {
        if (!paid_param.sub_compute_mode) {
          errmsg.push('子计算模式');
        }
        if (paid_param.sub_compute_mode === '1') {
          if (!paid_param.fixed_value) errmsg.push('固定值');
        } else {
          planCheckedKey[0].forEach((pk) => {
            if (!paid_param[pk]) errmsg.push(requiredPlan[pk]);
          });
        }
        if (Object.keys(paid_param.paid_params).length > 0) {
          for (let ppk in paid_param.paid_params) {
            if (!paid_param.paid_params[ppk]) {
              if (ppk === 'left_value' && itemIndex === 0) {
                // 第一个数据结构   left_value 可以为0
              } else {
                errmsg.push(requiredPlan[ppk]);
              }
            }
          }
        }
      });
    });
  }
  if (top === '4') {
    const pd = fd.planData;
    pd.forEach((planMode) => {
      const pmd = planMode.compute_mode;
      const planFD = falsyParamsFilter(planMode);
      // 顶层mode字段判断
      modePlanCheckedMap[pmd].forEach((k) => {
        if (!planFD[k]) errmsg.push(requiredPlan[k]);
      });
      if (errmsg.length) return errmsg;
      // mode内 plans 判断
      const planFNplans = planFD.plans;
      if (pmd !== '3') {
        const planCheckedKey = modePlanParamsCheckedMap[pmd][0];
        const planParamsKey = modePlanParamsCheckedMap[pmd][1];
        planFNplans.forEach((plan) => {
          planCheckedKey.forEach((pk) => {
            if (!plan[pk]) errmsg.push(requiredPlan[pk]);
          });
          if (plan.paid_params.length > 0) {
            plan.paid_params.forEach((param) => {
              planParamsKey.forEach((ppk) => {
                if (!param[ppk]) errmsg.push(requiredPlan[ppk]);
              });
            });
          }
        });
      } else {
        // mode === 3
        const planCheckedKey = [['unit', 'unit_work_time'], ['fixed_value']];
        planFNplans.forEach((plan, idx) => {
          if (!plan.ladder_unit) errmsg.push(requiredPlan.ladder_unit);
          if (errmsg.length) return errmsg;
          const painTemp = ['param_id', 'operator', 'type', 'value'];
          plan.paid_plan_param.forEach((param) => {
            painTemp.forEach((ppk) => {
              if (!param[ppk]) errmsg.push(requiredPlan[ppk]);
            });
          });
          plan.paid_params.forEach((paid_param, itemIndex) => {
            if (!paid_param.sub_compute_mode) {
              errmsg.push('子计算模式');
            }
            if (paid_param.sub_compute_mode === '1') {
              if (!paid_param.fixed_value) errmsg.push('固定值');
            } else {
              planCheckedKey[0].forEach((pk) => {
                if (!paid_param[pk]) errmsg.push(requiredPlan[pk]);
              });
            }
            if (Object.keys(paid_param.paid_params).length > 0) {
              for (let ppk in paid_param.paid_params) {
                if (!paid_param.paid_params[ppk]) {
                  if (ppk === 'left_value' && itemIndex === 0) {
                    // 第一个数据结构   left_value 可以为0
                  } else {
                    errmsg.push(requiredPlan[ppk]);
                  }
                }
              }
            }
          });
        });
      }
    });
  }
  return errmsg;
};

export const searchMatch = (s) => {
  if (!s) return {};
  const searchStr = s.split('?')[1];
  if (!searchStr) return {};
  const params = searchStr.split('&');
  let obj = {};
  params.forEach((str) => {
    const [key, value] = str.split('=');
    obj[key] = value;
  });
  return obj;
};

export const getNewPlans = (compute_mode) => {
  switch (compute_mode) {
    case '1':
      return [
        {
          ...PAY_PLAN_DEFINE,
          key: generateUniqKey('plans', 0),
          paid_params: [
            {
              ...PAY_ARG_DEFINE,
              key: generateUniqKey('paid_param', 0),
            },
          ],
        },
      ];
    case '2':
      return [
        {
          ...PAY_PLAN_DEFINE,
          key: generateUniqKey('plans', 0),
          sub_compute_mode: 2,
          paid_params: [
            {
              ...PAY_ARG_DEFINE,
              key: generateUniqKey('paid_param', 0),
            },
          ],
        },
      ];
    case '3':
      return [
        ...CALCMODE3_CONFIG.plans.map((item, index) => ({
          ...item,
          key: generateUniqKey('plans', index),
        })),
      ];
    default:
      return [];
  }
};
